import React from 'react';
import imgStep1 from 'assets/images/lightbox/step-1.png';
import imgStep2 from 'assets/images/lightbox/step-2.png';

const PopupWelcome = () => {

    return (
        <div id="message-popup-alert" className="white-popup message-popup-alert mcl">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <p className="text-center mb-4">Bienvenido(a)<br/>Para disfrutar de la cuponera Metro sigue estos pasos:</p>
                            </div>
                            <div className="col-12">
                                <ol>
                                    <li><img src={imgStep1} className="float-left"/> Selecciona tus cupones.</li>
                                    <li><img src={imgStep2} className="float-left"/> Genera un código y preséntalo en caja.</li>
                                </ol>
                            </div>
                            <div className="col-12 p-1">
                                <p className="text-center remember">Recuerda que solo puedes usar un código por ticket de compra, al generar un código nuevo el <strong>anterior queda inhabilitado</strong>.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default PopupWelcome;
